import rhfAppPermissions from "./rhfAppPermissions.js";
import rhfAppVersionFiles from "./rhfAppVersionFiles.js";
import typescriptModule from "./typescriptModule.js";

export default {
  rhfAppPermissions,
  rhfAppVersionFiles,
  typescriptModule,
};
